import Image from 'next/image'
import Script from 'next/script'
import { useEffect, useState } from 'react'
import { className } from '@/components/common/styles'
import mytest from '@/scripts/mytest'

export interface IBook {
  title: string
  status: string
  description: string
  imageUrl: string
}

interface Props {
  book: IBook
  nonce: string
}

interface IReview {
  id: string
  text: string
  author: string
}

const Msw = ({ book, nonce }: Props) => {
  const [reviews, setReviews] = useState<Array<IReview>>([])
  const [display, setDisplay] = useState(false)

  const test1 = () => {
    console.log('testbutton1 clicked')
  }

  useEffect(function setupListeners() {
    const handleClick = () => {
      console.log('handleClick() called')
      // NOTE: Call async function without awaiting; safe to ignore the promise in this event handler context
      // NOTE: Intentionally not awaited.
      void handleGetReviews()
    }

    const testbutton1Ref = document.getElementById('testbutton1')
    if (testbutton1Ref) {
      // Prevent adding unlimited event listeners (due to hot reload in dev mode).
      testbutton1Ref.removeEventListener('click', () => {
        // NOTE: Intentionally not awaited.
        void test1()
      })
      testbutton1Ref.addEventListener('click', () => {
        // NOTE: Intentionally not awaited.
        void test1()
      })
    } else {
      console.log('testbutton1Ref NOT FOUND')
    }

    const testbutton2Ref = document.getElementById('testbutton2')
    if (testbutton2Ref) {
      // Prevent adding unlimited event listeners (due to hot reload in dev mode).
      testbutton2Ref.removeEventListener('click', mytest)
      testbutton2Ref.addEventListener('click', mytest)
    } else {
      console.log('testbutton2Ref NOT FOUND')
    }

    const buttonLoadReviewsRef = document.getElementById('buttonLoadReviews')
    if (buttonLoadReviewsRef) {
      // Prevent adding unlimited event listeners (due to hot reload in dev mode).
      buttonLoadReviewsRef.removeEventListener('click', handleClick)
      buttonLoadReviewsRef.addEventListener('click', handleClick)
    } else {
      console.log('buttonLoadReviewsRef NOT FOUND')
    }

    return function cleanupListeners() {
      testbutton1Ref?.removeEventListener('click', () => {
        void test1()
      })
      testbutton2Ref?.removeEventListener('click', mytest)
      buttonLoadReviewsRef?.removeEventListener('click', handleClick)
    }
  }, [])

  // @@TODO: Prevent intermittent error in Chrome and Safari (see next.config.js).
  if (book === undefined) {
    console.log('book === undefined')
    return <div>book === undefined</div>
  }

  // copied from jl75/with-msw
  const handleGetReviews = async () => {
    console.log('Msw: handleGetReviews() called')
    console.log(
      'handleGetReviews() called - process.env.NEXT_PUBLIC_API_MOCKING=',
      process.env.NEXT_PUBLIC_API_MOCKING,
    )
    console.log(
      'handleGetReviews() called - process.env.NEXT_PUBLIC_BASE_URL=',
      process.env.NEXT_PUBLIC_BASE_URL,
    )
    console.log(
      'handleGetReviews() called - process.env.NODE_ENV=',
      process.env.NODE_ENV,
    )
    let url = ''
    if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
      url = 'https://mocked-server'
    } else {
      // @@TODO: components/main/Msw.tsx and [locale]/main/msw/index.tsx
      // @@TODO: Use absolute URLs only for unit tests (Vitest).
      // @@TODO: Separate case for Playwright
      url =
        process.env.NODE_ENV === 'test'
          ? (process.env.NEXT_PUBLIC_BASE_URL as string)
          : ''
    }
    console.log('handleGetReviews() url=', url)
    const res = await fetch(`${url}/api/msw/reviews`)
    //console.log('res=', res)
    const reviews = (await res.json()) as IReview[]
    //console.log('reviews=', reviews)
    setReviews(reviews)
    setDisplay(true)
  }

  const getReviews = async () => {
    setDisplay(true)
    const url = '/api/msw/reviews'
    //const vercel_share = '?_vercel_share=5yJEmW601RJBWGO2A54UqXOZzIWAAZxI'
    const vercel_share = '' // @@BUG: 20231114
    const safeUrl =
      process.env.NODE_ENV === 'test'
        ? 'http://localhost:3000' + url + vercel_share
        : url
    console.log('safeUrl=', safeUrl)
    try {
      const res = await fetch(safeUrl)
      // @@TODO: add header for ngrok
      /*
      const res = await fetch(
        'https://enjoyed-roughly-swan.ngrok-free.app/api/msw/reviews',
        { headers: { 'ngrok-skip-browser-warning': 'any' } },
      )
      */
      console.log('res=', res)
      if (res.status >= 400) {
        const message = `${res.status} ${res.statusText}`
        throw new Error(message)
      }
      const result = (await res.json()) as IReview[]
      //const result = res as unknown as IReview[]
      console.log('getReviews() result=', result)
      setReviews(result)
      return // @@TODO: Remove if test succeeds: Promise.resolve()
    } catch (error) {
      const errorMessage = `${getReviews.name} - error:`
      console.log(errorMessage, error)
    }
  }

  return (
    <>
      <Script id="handle" nonce={nonce}>
        {`console.log('inside inline Script'); const testbutton2 = document.getElementById('testbutton2'); if (testbutton2) { testbutton2.click(); console.log('clicked testbutton2'); }`}
      </Script>
      <div>
        <div className="w-40 h-auto">
          <Image
            src={book.imageUrl}
            alt={book.title}
            // @@TODO: [WARNING] Image with src "/book-cover.jpg" has either width or height modified, but not the other.
            // If you use CSS to change the size of your image, also include the styles 'width: "auto"' or 'height: "auto"' to maintain the aspect ratio.
            width={100}
            height={160}
            className="w-full h-auto"
          />
        </div>
        <b>
          mocking={process.env.NEXT_PUBLIC_API_MOCKING ? 'enabled' : 'disabled'}
        </b>
        <h2>
          <div className="font-medium">{book.title}</div>
        </h2>
        <p>{book.status}</p>
        <p>{book.description}</p>
        <div className="grid gap-y-2">
          <button type="button" className={className} id="testbutton1">
            testbutton1
          </button>
          <button type="button" className={className} id="testbutton2">
            testbutton2
          </button>
          <button
            type="button"
            className={className}
            id="buttonLoadReviews"
            // @@TODO: ESLint discussion https://github.com/typescript-eslint/typescript-eslint/issues/4619
            // Suggested style to mark the promise as purposely dangling
            //onClick={handleClick}
          >
            Load reviews
          </button>
          <button
            type="button"
            className={className}
            onClick={() => setDisplay(!display)}
          >
            Show + Hide
          </button>
        </div>
        {reviews.length > 0 && display && (
          <div>
            Must not show at start...
            <ul>
              {reviews.map((review) => (
                <li key={review.id}>
                  <p>{review.text}</p>
                  <p>{review.author}</p>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </>
  )
}

export default Msw
